<template>
  <div style="margin-top: -10px;">
    <div class="row">
           <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                <span class="row-table-font-margins" style="font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center">{{buildingName}} / Recurring Expenses</span>
                </div>
            </div>
           <div class="col-4 add-button-section">
               <div class="text-right" style="padding: 5px;">
                   <!--<span style="margin-right:5px">Add New Unit</span>
                <router-link class="btn btn-table" :to="{
          name: 'property',
          params: { buildingId: buildingId, buildingName: buildingName },
        }"><i class="fas fa-plus"></i></router-link>-->
                   <span style="width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                       <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                   </span>

                   <span @click="showSearch()"
                         style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                       <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                   </span>
                   <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                   <userMenu />
               </div>
           </div>
        </div>
    <div class="row">

        <div class="col-md-offset-10 col-2 add-button-section">
            <div class="text-right" style="padding: 5px;">
                <span style="margin-right:5px">Add New Recurring Expense</span>
                <router-link class="btn btn-table" :to="{
            name: 'recurringexpense',
            params: { buildingId: buildingId, buildingName: buildingName },
          }"><i class="fas fa-plus"></i></router-link>
            </div>
        </div>
    </div>
     <div v-if="false" class="row" style="margin-left: 1px;">
      <div
        class="col-6 col-sm-5 col-md-3 search"
        style="width: 245px; margin-bottom: 11px;"
      >
        <span class="fa fa-search"></span>
        <input
          type="text"
          class="form-control"
          name="searchText"
          id="searchText"
          placeholder="Search Contact..."
          v-model="filter"
        />
      </div>
      <div
        class="col-12 col-sm-7 col-md-9 pullLeft"
        style="margin-top: -11px; text-align: right;"
      >
        <router-link
          class="btn btn-primary"
          :to="{
            name: 'recurringexpense',
            params: { buildingId: buildingId, buildingName: buildingName },
          }"
          >Add Recurring expense</router-link
        >
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-condensed">
        <thead>
          <tr>
            <th  scope="col" style="width: 19%">No</th>
            <th scope="col" style="width: 19%">Expense Types</th>
            <th scope="col" style="width: 19%">Amount</th>
            <th scope="col" style="width: 19%">Month(s)</th>
            <th scope="col" style="width: 19%">Expired</th>
            <th scope="col" style="width: 5%"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(expense, key) in getRecurringExpenses"
            class="clickable-row"
          >
            <td scope="row" class="clickable-column">
              <a @click.prevent="editItem(expense)">{{ ++key }}</a>
            </td>
            <td class="clickable-column">
              <a @click.prevent="editItem(expense)">{{
                expense.expenseType.name
              }}</a>
            </td>
            <td class="clickable-column">
              <a @click.prevent="editItem(expense)">{{ $filters.currency(expense.amount, "€") }}</a>
            </td>
            <td class="clickable-column">
              <a @click.prevent="editItem(expense)">{{ expense.period }}</a>
            </td>
            <td class="clickable-column">
              <a @click.prevent="editItem(expense)">{{ expense.isExpired }}</a>
            </td>
            <td>
              <a
                class="btn btn-table"
                style="display: inline-block; "
                @click.prevent="deleteItem(expense)"
                ><i class="fas fa-times"></i></a
              >
              <a
                disabled
                class="btn btn-table"
                style="margin-left:6px;
                  display: inline-block;
                  
                "
                @click.prevent="deleteItem(expense)"
                ><i class="fas fa-pen"></i></a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- MODAL IS HERE -->
    <modal
      :scrollable="true"
      name="deleteAlert"
      @before-open="beforeOpen"
      height="auto"
      :minHeight="150"
      width="400"
    >
      <div class="" role="document">
        <div class="">
          <!-- Modal content-->
          <deleteAlert
            v-on:close="modalClosed"
            :entity-id="selectedItemId"
            request="recurringExpenses"
            entity="expense"
          />
        </div>
      </div>
    </modal>
  </div>
</template>
<style scoped>
@media (max-width: 599px) {
  .pullLeft {
    text-align: left !important;
    margin-left: -11px;
  }
}
</style>
<script>
import { mapState } from "vuex";
import { format } from "date-fns";
export default {
  data: function () {
    return {
      filter: "",
      recurringExpenses: [],
      buildingId: 0,
    //  buildingName: "",
      selectedItemId: 0,
      visibleSearch: false,
    };
  },
  mounted() {
    this.buildingId = this.$route.params.buildingId;
   // this.buildingName = this.$route.params.buildingName;
    //this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    getRecurringExpenses() {
      var committees = this.recurringExpenses.filter((supplier) => {
        return supplier.expenseType.name
          .toLowerCase()
          .includes(this.filter.toLowerCase());
      });

      return committees;
    },
  },
  methods: {
    showSearch() {
      this.visibleSearch = !this.visibleSearch;
    },
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/recurringexpenses/building?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.recurringExpenses = data;
        });
    },
    modalClosed: function (itemDeleted) {
      if (itemDeleted) this.fetchStatement();
    },
    editItem: function (item) {
      this.$router.push({
        name: "recurringexpense",
        params: {
          id: item.id,
          buildingId: this.buildingId,
          buildingName: this.buildingName,
        },
      });
    },
    deleteItem: function destroy(item) {
      this.selectedItemId = item.id;
      this.deleteAlert();
    },
    deleteAlert: function () {
      this.$modal.show("deleteAlert");
    },
    customFormatter(date) {
      return format(date, "dd/MM/yyyy");
    },
  },
};
</script>
